<template>
    <div>
        <v-row>
            <v-col class="col-1">
                <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                        <v-btn fab dark color="primary" v-on="on">
                            <v-icon dark>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="editedItem.numero" label="Número"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="editedItem.nome"
                                                      label="Descrição"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                            <v-btn color="blue darken-1" text
                                   @click="save"
                                   class="ma-2"
                                   :loading="loading"
                                   :disabled="loading"
                            >Salvar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>

            <v-col class="col-4 offset-7">

                <form v-on:submit.prevent="getFromApi()">
                    <v-text-field
                            class="pa-0"
                            v-model="filters.quickSearch"
                            outlined
                            autocomplete="off"
                            label="Quick search"
                            placeholder="código ou descrição"
                            :append-icon="'mdi-magnify'"
                            hint="código ou descrição"
                            dense
                    ></v-text-field>
                </form>

            </v-col>
        </v-row>

        <v-data-table
                :headers="headers"
                :items="items"
                item-key="id"
                :options.sync="options"
                :server-items-length="totalItems"
                class="elevation-1"
                :loading="loading"
                loading-text="Carregando..."
                no-data-text="Nenhum registro encontrado"
                dense
                show-current-page="true"
                :footer-props="{
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  'items-per-page-options': [5, 10, 30, 70, 100],
                }"
                :items-per-page="30"
        >
            <template v-slot:item.actions=" { item }
        ">
                <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                        color="primary"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                        small
                        @click="deleteItem(item)"
                        color="error"
                >
                    mdi-delete
                </v-icon>
            </template>
            <!--            <template v-slot:no-data>-->
            <!--                <v-btn color="primary" @click="getFromApi">Reset</v-btn>-->
            <!--            </template>-->
        </v-data-table>

        <!--        <template v-slot:top>-->
        <!--            <v-toolbar flat>-->
        <v-dialog
                v-model="alertDialog"
                max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    <span class="orange--text">Atenção</span>
                </v-card-title>

                <v-card-text>
                    {{alertDialogText}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="primary darken-1"
                            text
                            @click="alertDialog = false"
                    >
                        Ok, entendi
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--            </v-toolbar>-->
        <!--        </template>-->

    </div>


</template>

<script>
    export default {
        data: () => ({
            endpoint: 'filiais',

            items: [],
            totalItems: 0,
            options: {},
            dialog: false,
            alertDialog: false,
            alertDialogText: "",
            filters: {
                filial: '',
                quickSearch: '',
            },

            // btn loading
            loader: null,
            loading: false,

            headers: [
                {
                    text: 'Ações',
                    value: 'actions',
                    sortable: false,
                    width: '10%',
                },
                {
                    text: 'Número',
                    align: 'start',
                    sortable: true,
                    value: 'numero',
                    width: '20%',
                },
                {
                    text: 'Nome',
                    sortable: true,
                    value: 'nome'
                },
            ],
            editedIndex: -1,
            editedItem: {
                numero: '',
                nome: '',
            },
            defaultItem: {
                numero: '',
                nome: '',
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'Novo Item' : 'Edição do Item'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },

            options: {
                handler() {
                    this.getFromApi();
                },
                deep: true,
            }

        },

        methods: {
            getFromApi() {
                this.loading = true;

                const {sortBy, sortDesc, page, itemsPerPage} = this.options;

                let params = {
                    filters: this.filters,
                    sortBy: sortBy,
                    sortDesc: sortDesc,
                    page: page,
                    itemsPerPage: itemsPerPage,
                };

                axios.get(this.$store.getters.getUsrEndpoint + '/' + this.endpoint, {params: params})
                    .then((response) => {
                            this.items = response.data.items;
                            this.totalItems = response.data.totalItems;

                            this.loading = false;
                        }, (error) => {
                            console.log(error);
                        }
                    )
                    .catch(error => {
                        console.log(error)
                        // this.errored = true
                    })
                    .finally(() => this.loading = false)
                ;
            },

            editItem(item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                // this.editedItem.departamento = this.editedItem.departamento_id;
                this.dialog = true
            },

            deleteItem(item) {
                const index = this.items.indexOf(item)
                if (confirm('Tem certeza que quer remover este item?')) {
                    axios
                        .delete('/' + this.endpoint + '/' + item.id)
                        .then((response) => {
                                this.close();
                                this.dialog = false

                                // this.items.splice(index, 1);
                                // this.totalItems = this.totalItems - 1;
                                this.getFromApi();

                            }, (error) => {
                                this.alertDialog = true;
                                // if (error.response.status == 409) {
                                // }
                                this.alertDialogText = "Houve um problema ao remover o registro";
                            }
                        )
                        .catch(error => {
                            console.log(error)
                            // this.errored = true
                        })
                        .finally(() => {
                            this.loading = false;
                            this.loader = null;
                        })
                    ;
                }
            },

            close() {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save() {
                this.loading = true;
                this.loader = 'loading';

                if (this.editedIndex > -1) {
                    axios
                        .patch('/' + this.endpoint + '/' + this.editedItem.id, this.editedItem)
                        .then((response) => {
                                this.close();

                                // Object.assign(this.items[this.editedIndex], this.editedItem);
                                this.getFromApi();
                            }, (error) => {
                                this.alertDialog = true;
                                // if (error.response.status == 409) {
                                // }
                                this.alertDialogText = "Houve um problema ao modificar o registro";
                            }
                        )
                        .catch(error => {
                            console.log(error)
                            // this.errored = true
                        })
                        .finally(() => {
                            this.loading = false;
                            this.loader = null;
                        })
                    ;

                } else {
                    axios
                        .post(this.$store.getters.getUsrEndpoint + '/' + this.endpoint, this.editedItem)
                        .then((response) => {
                                // this.items = response.data.items;
                                // this.totalItems = response.data.totalItems;

                                this.close();

                                // this.items.push(this.editedItem);
                                // this.totalItems = this.totalItems + 1;
                                this.getFromApi();

                                this.loading = false;
                            }, (error) => {
                                this.alertDialog = true;
                                if (error.response.status == 409) {
                                    this.alertDialogText = "Já existe um registro com o código informado";
                                }
                            }
                        )
                        .catch(error => {
                            console.log(error)
                            // this.errored = true
                        })
                        .finally(() => {
                            this.loading = false;
                            this.loader = null;
                        })
                    ;
                }
            },
        },
    }
</script>
